"use client";

import React from "react";
import footerData from "../content/footer.json";

export default function Footer() {
  return (
    <footer style={footerStyle}>
      <div style={containerStyle}>
        {footerData.sections.map((section, index) => (
          <div key={index} style={columnStyle}>
            <h4 style={titleStyle}>{section.title}</h4>
            <ul style={listStyle}>
              {section.links.map((link, i) => (
                <li key={i} style={listItemStyle}>
                  <a href={link.url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </footer>
  );
}

// Inline styles
const footerStyle = {
  backgroundColor: "#333",
  color: "#fff",
  padding: "20px 0",
  marginTop: "40px"
};

const containerStyle = {
  maxWidth: "800px",
  margin: "0 auto",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start"
};

const columnStyle = {
  flex: 1,
  padding: "0 10px",
  minWidth: "0"
};

const titleStyle = {
  marginBottom: "10px",
  fontSize: "16px"
};

const listStyle = {
  listStyle: "none",
  padding: 0,
  margin: 0
};

const listItemStyle = {
  marginBottom: "8px"
};

const linkStyle = {
  color: "#fff",
  textDecoration: "none",
  fontSize: "14px"
};
